module.exports = __webpack_public_path__ + "static/media/book11_inspirerende-leider.70bce4bf.png";